import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// Figma "Section" (Texting Setup): title 32px above the content; blocks, fields and the divider
// 24px apart; Configuration fields in a 340px column.
export const styles = (theme: Theme) => {
	return ({
		card: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(4),
		},
		cardContent: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(3),
		},
		heading: {
			fontWeight: "bold",
			fontSize: 18,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		section: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(3),
		},
		subheading: {
			fontWeight: "bold",
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		divider: {
			borderColor: theme.palette.custom.divider,
		},
		// Figma puts the Status chip 10px under its label, and a read-only value 8px under its label.
		statusField: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			gap: 10,
		},
		readOnlyField: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1),
		},
		label: {
			fontSize: 14,
			lineHeight: "20px",
			color: theme.palette.custom.textSecondary,
		},
		value: {
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		field: {
			maxWidth: 340,
		},
		// Resend Verification Text is the design kit's tertiary button: teal Button/Medium, no fill.
		resend: {
			padding: theme.spacing(1, 0),
			minWidth: 0,
			fontSize: 16,
			fontWeight: 590,
			lineHeight: "20px",
			color: theme.palette.custom.tertiaryAction,
			"&:hover": {
				backgroundColor: "transparent",
				textDecoration: "underline",
			},
		},
		otpSent: {
			display: "inline-flex",
			alignItems: "center",
			gap: theme.spacing(0.5),
			fontSize: 16,
			fontWeight: 590,
			lineHeight: "20px",
			color: theme.palette.custom.textPrimary,
		},
		otpSentIcon: {
			color: theme.palette.custom.tertiaryAction,
		},
	} satisfies Record<string, CSSObject>);
};
